import { matchPath } from 'react-router-dom';

export const pathMatchesRoute = (pathname: string, route: string) =>
  !!matchPath(pathname, { path: route, exact: true });
